import React from 'react';
import { useIntl } from 'react-intl';
import style from './style.module.scss';

export function NotFoundPage(): JSX.Element {
    const { formatMessage } = useIntl();
    return (
        <>
            <div className={style.notFoundRoot}>
                <div className={style.title}>4 0 4</div>
                <div className={style.label}>{formatMessage({ id: 'notFoundPageNotFound' })}</div>
                <a className={style.link} href="/">
                    {formatMessage({
                        id: 'notFoundPageBackToInitialLocation',
                    })}
                </a>
            </div>
        </>
    );
}
